<template>
  <div id="settingMenu" v-if="((this.$global.menuLeadsPeek && this.$global.menuUserType != 'client' && this.$global.menuUserType != 'sales') || (this.$global.menuUserType == 'sales' && this.$global.stripeaccountconnected  && this.$global.isAccExecutive == 'T'))" class="fixed-plugin" v-click-outside="closeDropDown">
    <div class="dropdown show-dropdown" :class="{ show: isOpen }">
      <a data-toggle="dropdown" class="settings-icon">
        <i class="fas fa-cogs fa-2x" @click="toggleDropDown"> </i>
      </a>
       <ul class="dropdown-menu" :class="{ show: isOpen }">
         <li class="header-title"><i class="fas fa-tools"></i>System Settings</li>
         <li class="adjustments-line">
            <ul class="listree">
                <li v-if="!this.$global.systemUser && this.$global.creditcardsetup && this.$global.stripeaccountconnected">
                  <i class="fas fa-users"></i><router-link to="/configuration/client-management">Client Management</router-link>
                </li>
                <li v-if="this.$global.systemUser">
                  <i class="fas fa-sitemap"></i><router-link to="/configuration/agency-list">Agency List</router-link>
                </li>
                <li v-if="this.$global.menuUserType != 'sales'">
                  <i class="fas fa-users-cog"></i><router-link to="/configuration/administrator-list">Administrator List</router-link>
                </li>
                <li v-if="this.$global.systemUser && this.$global.menuUserType != 'sales'">
                  <i class="fas fa-users-cog"></i><router-link to="/configuration/sales-account-list">Sales Account List</router-link>
                </li>
                <li  v-if="this.$global.menuUserType != 'sales' && false">
                  <i class="fas fa-user-shield"></i><router-link to="/configuration/role-list">Role List</router-link>
                </li>
                <li v-if="this.$global.menuUserType != 'client'">
                  <i class="fas fa-sliders-h"></i><router-link to="/configuration/general-setting">General Settings</router-link>
                </li>
                <li v-if="this.$global.systemUser && this.$global.menuUserType != 'sales' && false">
                  <i class="far fa-chart-line"></i><router-link to="/configuration/data-enrichment">Data Enrichment</router-link>
                </li>
                <li v-if="this.$global.systemUser && this.$global.menuUserType != 'sales'">
                  <i class="far fa-chart-line"></i><router-link to="/configuration/opt-out-list">Exclusion List</router-link>
                </li>
                <li v-if="this.$global.systemUser && this.$global.menuUserType != 'sales' && this.$global.rootcomp">
                  <i class="far fa-chart-line"></i><router-link to="/configuration/report-analytics">Report Analytics</router-link>
                </li>
            </ul>
         </li>
       </ul>
      <!--
        <ul class="dropdown-menu" :class="{ show: isOpen }">
        <li class="header-title">Sidebar Background</li>
        <li class="adjustments-line">
          <a class="switch-trigger background-color">
            <div class="badge-colors text-center">
              <span
                v-for="item in sidebarColors"
                :key="item.color"
                class="badge filter"
                :class="[`badge-${item.color}`, { active: item.active }]"
                :data-color="item.color"
                @click="changeSidebarBackground(item);"
              ></span>
            </div>
            <div class="clearfix"></div>
          </a>
        </li>

        <li class="header-title">Sidebar Mini</li>
        <li class="adjustments-line">
          <div class="togglebutton switch-sidebar-mini">
            <span class="label-switch">OFF</span>
            <base-switch
              v-model="sidebarMini"
              @input="minimizeSidebar"
            ></base-switch>
            <span class="label-switch label-right">ON</span>
          </div>

          <div class="togglebutton switch-change-color mt-3">
            <span class="label-switch">LIGHT MODE</span>
            <base-switch v-model="darkMode" @input="toggleMode"></base-switch>
            <span class="label-switch label-right">DARK MODE</span>
          </div>
        </li>

        <li class="button-container mt-4">
          <a
            href="https://demos.creative-tim.com/vue-black-dashboard-pro/documentation"
            target="_blank"
            rel="noopener"
            class="btn btn-default btn-block btn-round"
          >
            Documentation
          </a>
          <a
            href="https://creative-tim.com/product/vue-black-dashboard-pro"
            target="_blank"
            rel="noopener"
            class="btn btn-primary btn-block btn-round"
          >
            Buy for $59
          </a>
          <a
            href="https://demos.creative-tim.com/vue-black-dashboard"
            target="_blank"
            rel="noopener"
            class="btn btn-info btn-block btn-round"
          >
            Free Version
          </a>
        </li>
      </ul>
      -->
    </div>
  </div>
</template>
<script>
  import { BaseSwitch } from 'src/components';

  export default {
    name: 'sidebar-share',
    components: {
      //BaseSwitch
    },
    props: {
      backgroundColor: String
    },
    data() {
      return {
        sidebarMini: false,
        darkMode: true,
        isOpen: false,
        sidebarColors: [
          { color: 'primary', active: false, value: 'primary' },
          { color: 'vue', active: false, value: 'vue' },
          { color: 'info', active: false, value: 'blue' },
          { color: 'success', active: false, value: 'green' },
          { color: 'warning', active: false, value: 'orange' },
          { color: 'danger', active: true, value: 'red' }
        ]
      };
    },
    methods: {
      toggleDropDown() {
        if (!this.isOpen) {
          this.isOpen = false;
        }else{
          this.isOpen = true;
        }
      },
      closeDropDown() {
        this.isOpen = false;
      },
      toggleList(list, itemToActivate) {
        list.forEach(listItem => {
          listItem.active = false;
        });
        itemToActivate.active = true;
      },
      changeSidebarBackground(item) {
        this.$emit('update:backgroundColor', item.value);
        this.toggleList(this.sidebarColors, item);
      },
      toggleMode(type) {
        let docClasses = document.body.classList;
        if (type) {
          docClasses.remove('white-content');
        } else {
          docClasses.add('white-content');
        }
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize();
      }
    }
  };
</script>
<style scoped lang="scss">
  @import '~@/assets/sass/dashboard/custom/variables';

  .settings-icon {
    cursor: pointer;
  }

  .badge-vue {
    background-color: $vue;
  }
</style>
